import { withStyles } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Trans, useTranslations } from "../../../adapters/i18n";
import * as action from "../../../redux/actions";
import { useForgotPassword } from "../hooks/useForgotPassword";
import styles from "./styles";

const SUPPORT_EMAIL = "suporte@prodap.com.br";

const ForgotPasswordPage = ({ match, classes, notifyError, notifySuccess }) => {
  const { origem } = match.params || {};
  const { t } = useTranslations();

  const { onSubmit, navigateToLogin, error } = useForgotPassword({
    origem,
    notifyError,
    notifySuccess,
  });

  return (
    <div className={classes.container}>
      <div className={classes.loaderWrapper}>
        <div className={classes.loader}></div>
      </div>
      <div className={classes.loginPage}>
        <div className={classes.loginForm}>
          <header>
            <div className={classes.logoWrapper}>
              <img
                className={classes.logoWrapperImg}
                src="https://storage.googleapis.com/armazenamento-imagens/logo/logo-Farmtell-Views-Cor.svg"
                alt=""
              />
            </div>

            <div className={classes.greetings}>
              <h1 className={classes.greetingWelcome}>
                {t("login:forgot-password-question")}
              </h1>
              <p className={classes.greetingSubtitle}>
                {t("login:reset-password-instructions")}
              </p>
            </div>
          </header>

          <form className={classes.form} onSubmit={onSubmit}>
            <div
              className={[
                classes.inputWrapper,
                error ? classes.onError : "",
              ].join(" ")}
            >
              <label className={classes.formControlLabel} htmlFor="username">
                {t("common:fields.email")}
              </label>
              <input
                className={classes.loginInput}
                type="text"
                name="email"
                placeholder={t("login:enter-email")}
              />
              <div className={classes.icon}>
                <img
                  width="17px"
                  height="18px"
                  src="https://storage.googleapis.com/armazenamento-imagens/assets/email-new-blue.svg"
                  alt=""
                />
              </div>
            </div>

            <p className={classes.resetPasswordInfo}>
              <Trans
                i18nKey="login:reset-password-helper-text"
                values={{ email: SUPPORT_EMAIL }}
                components={{
                  mailto: (
                    <a
                      className={classes.formFooterA}
                      href={`mailto:${SUPPORT_EMAIL}`}
                    >
                      {{ email: SUPPORT_EMAIL }}
                    </a>
                  ),
                }}
              />
            </p>

            <button className={classes.submitButton} type="submit">
              {t("login:send-reset-link")}
            </button>
          </form>

          <div
            onClick={navigateToLogin}
            className={classes.navigateToLoginLink}
          >
            <img
              alt={t("common:actions.go-back")}
              className={classes.arrowIcon}
              src="../images/arrow-back.svg"
            />
            <span>{t("common:actions.go-back-to-login")}</span>
          </div>
        </div>

        <div className={classes.bgOxWrapper}></div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  notifyError: action.notifyError,
  notifySuccess: action.notifySuccess,
};

export default compose(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)(ForgotPasswordPage);
